import { FETCH_ALL_SKUS } from '../actions/types';
export default function (state={},action) {
    switch (action.type){
        case FETCH_ALL_SKUS:
            return action.payload || false;
        default:
            return state;
    }
}